// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function HamburgerMenu({
  width = "16px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 14"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z"
        transform="translate(6160)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Index/Hamburger.js